import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/telecom-services/banner-telecom.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Telecom Software Development Company
              </h1>
              <span>Agile Telecom Solutions for Rapid Growth</span>
              <p style={{ marginTop: "10px" }}>
                Move towards the future of connectivity with our
                state-of-the-art telecom software development services,
                employing advanced AI and cloud-native technologies to elevate
                performance.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
